import { render, staticRenderFns } from "./CWRecord.vue?vue&type=template&id=9ce2f98c&scoped=true&"
import script from "./CWRecord.vue?vue&type=script&lang=js&"
export * from "./CWRecord.vue?vue&type=script&lang=js&"
import style0 from "./CWRecord.vue?vue&type=style&index=0&id=9ce2f98c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce2f98c",
  null
  
)

export default component.exports